export enum ActionTypes {
    sendEmail = "sendEmail",
    stopRecipe = "stopRecipe",
    startRecipe = "startRecipe",
    deleteRecipe = "deleteRecipe",
    stopFlow = "stopFlow",
    stopAllFlows = "stopAllFlows",
    startFlow = "startFlow",
    deleteConnection = "deleteConnection",
    deleteCanvasApp = "deleteCanvasApp",
    deleteFlow = "deleteFlow",
    deleteEnvironment = "deleteEnvironment",
    quarantineApplication = "quarantineApplication",
    unquarantineApplication = "unquarantineApplication",
    sendWebhook = "sendWebhook",
    stopAllRecipes = "stopAllRecipes",
    addOwnerToCanvasApp = "addOwnerToCanvasApp",
    addOwnerToCustomConnector = "addOwnerToCustomConnector",
    addOwnerToFlow = "addOwnerToFlow",
    addOwnerToEnvironment = "addOwnerToEnvironment",
    addOwnerToConnection = "addOwnerToConnection",
    addOwnerToCopilot = "addOwnerToCopilot",
    exemptViolation = "exemptViolation",
    resetViolationStatus = "resetViolationStatus",
    wait = "wait",
    secureFlowSteps = "secureFlowSteps",
    setCopilotAuthentication = "setCopilotAuthentication",
    removeAccessFromCopilot = "removeAccessFromCopilot",
    addLabel = "addLabel",
    removeAccess = "removeAccess",
    isolateFlowResource = "isolateFlowResource",
    isolateCopilotResource = "isolateCopilotResource",
}

export const AddOwnerActions = [
    ActionTypes.addOwnerToCanvasApp,
    ActionTypes.addOwnerToConnection,
    ActionTypes.addOwnerToCustomConnector,
    ActionTypes.addOwnerToEnvironment,
    ActionTypes.addOwnerToFlow,
    ActionTypes.addOwnerToCopilot,
];

export const RemovePermissionsActions = [ActionTypes.removeAccessFromCopilot];

export const RemoveAccessActions = [ActionTypes.removeAccess];

export const IsolateResourceActions = [ActionTypes.isolateCopilotResource, ActionTypes.isolateFlowResource];
